export class ProjectState{
    static alphabet_sharps:number = 0
    static alphabet_flats:number = 1
    static alphabet_hawaiian:number = 2
    static isLoggedIn = false
    alphabetType:number
    setter:Function
    //hasLoggedIn:boolean = false
    isMobile:boolean
    isLoggedIn:boolean
    validation:string
    constructor(setter:Function){
      this.setter = setter
      this.isLoggedIn = ProjectState.isLoggedIn
      this.validation = 'SeeTheMusic'
      this.alphabetType = ProjectState.alphabet_sharps
      this.isMobile = (window.innerWidth < 900)
    }
    setAlphabetType = (alphabetType:number) => this.setState({ alphabetType: alphabetType })
    getAlphabetType = () => {return(this.alphabetType)}
    setLoggedIn = (b:boolean) => this.setState({isLoggedIn: b })
    setValidation = (data:any) =>{
      if(data.login === this.validation){
        this.setState({isLoggedIn: true })
      }
    }
    setState = (obj:any) => {
      this.setter((state:ProjectState) => (obj))
    }
  }